import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Spinner,
  Text,
  IconButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react";
import { AddIcon, EditIcon, DeleteIcon } from "@chakra-ui/icons";
import axios from "../../axiosConfig";
import WidgetStepForm from "./WidgetStepForm";

const WidgetStepsList = ({ widgetId }) => {
  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingStep, setEditingStep] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const fetchSteps = async () => {
    try {
      const res = await axios.get(`/widgets/${widgetId}/widget_steps`);
      setSteps(res.data);
    } catch (err) {
      console.error("Error fetching steps:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSteps();
  }, [widgetId]);

  const handleDelete = async (stepId) => {
    try {
      await axios.delete(`/widgets/${widgetId}/widget_steps/${stepId}`);
      fetchSteps();
    } catch (err) {
      console.error("Error deleting step:", err);
    }
  };

  const handleSave = async (data) => {
    try {
      if (editingStep) {
        await axios.put(`/widgets/${widgetId}/widget_steps/${editingStep.id}`, {
          widget_step: data,
        });
      } else {
        await axios.post(`/widgets/${widgetId}/widget_steps`, {
          widget_step: data,
        });
      }
      fetchSteps();
      onClose();
      setEditingStep(null);
    } catch (err) {
      console.error("Error saving step:", err);
    }
  };

  if (loading) return <Spinner size="lg" />;

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={4}>
        <Heading size="md">Widget Steps</Heading>
        <Button
          leftIcon={<AddIcon />}
          colorScheme="orange"
          onClick={() => {
            setEditingStep(null);
            onOpen();
          }}
        >
          Add Step
        </Button>
      </Flex>

      {steps.length === 0 ? (
        <Text>No steps defined yet.</Text>
      ) : (
        steps.map((step) => (
          <Flex
            key={step.id}
            justify="space-between"
            align="center"
            p={3}
            mb={2}
            borderWidth="1px"
            borderRadius="md"
          >
            <Text>{step.title}</Text>
            <Flex gap={2}>
              <IconButton
                icon={<EditIcon />}
                aria-label="Edit step"
                size="sm"
                onClick={() => {
                  setEditingStep(step);
                  onOpen();
                }}
              />
              <IconButton
                icon={<DeleteIcon />}
                aria-label="Delete step"
                size="sm"
                colorScheme="red"
                onClick={() => handleDelete(step.id)}
              />
            </Flex>
          </Flex>
        ))
      )}

      {/* Modal for Add/Edit */}
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {editingStep ? "Edit Step" : "Add Step"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <WidgetStepForm
              initialData={editingStep}
              onSubmit={handleSave}
              onCancel={() => {
                setEditingStep(null);
                onClose();
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default WidgetStepsList;